<template>
  <!-- <pre v-if="responseData">detailsUmurData={{ responseData.data_information.year }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/AHLI MAJLIS PBT.png"
        alt="AHLI MAJLIS PBT"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>

    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
          />
        </div>
      </div>

      <div class="majlis-content">
        <div class="majlis-item">
          <img
            src="@/assets/jkt/male.png"
            alt="Male Image"
            class="majlis-image"
          >
          <!-- males  -->
          <div class="majlis-numbers">
            <p>{{ numberWithCommas(ahli.overallData.lelaki) }} Orang </p> 
            <span>{{ calculatePercentage(ahli.overallData.lelaki,ahli.overallData.wanita,ahli.overallData.keseluruhan).malePercentage }}%</span>
          </div>
        </div>
        <div class="majlis-item">
          <img
            src="@/assets/jkt/female.png"
            alt="Female Image"
            class="majlis-image"
          >
          <div class="majlis-numbers">
            <p>{{ numberWithCommas(ahli.overallData.wanita) }} Orang</p>
            <span>{{ calculatePercentage(ahli.overallData.lelaki,ahli.overallData.wanita,ahli.overallData.keseluruhan).femalePercentage }}%</span>
          </div>
        </div>
      </div>
      
      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT WANITA BAGI SETIAP NEGERI</h2>
      <div class="chart-wrapper">  
        <Female :data="FemaleData" />
        <Update />
      </div> 
     

      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT LELAKI BAGI SETIAP NEGERI</h2>
      <div class="chart-wrapper">
        <Male :data="MaleData" />
        <Update />
      </div>
    </div>

    <!--
      <div class="content-wrapper">
      <h2>PERATUSAN AHLI MAJLIS PBT WANITA</h2>
      <div class="chart-wrapper">
      <Bar 
      :chart-data="PeratusanData"
      :chart-categories="PeratusanNames"
      :chart-colors="['#42a5f5']"
      />
      <Update />
      </div>
      </div> 
    -->

    <div class="content-wrapper">
      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT BERSTATUS OKU</h2>
      <div class="image-grid">
        <!-- First Row of Images -->
        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/kelantan1.png"
            alt="Kelantan"
          >
          <div class="text-overlay">
            <p class="state-name">
              KELANTAN
            </p>
            <p class="state-number">
              {{ getStatusOku('Kelantan') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/kedah1.png"
            alt="Kedah"
          >
          <div class="text-overlay">
            <p class="state-name">
              KEDAH
            </p>
            <p class="state-number">
              {{ getStatusOku('Kedah') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/johor2.png"
            alt=""
          >
          <div class="text-overlay">
            <p class="state-name">
              JOHOR
            </p>
            <p class="state-number">
              {{ getStatusOku('Johor') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/sarawak.png"
            alt="Penang"
          >
          <div class="text-overlay">
            <p class="state-name">
              SARAWAK
            </p>
            <p class="state-number">
              {{ getStatusOku('Sarawak') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/selangor.png"
            alt=""
          >
          <div class="text-overlay">
            <p class="state-name">
              SELANGOR
            </p>
            <p class="state-number">
              {{ getStatusOku('Selangor') }}
            </p>
          </div>
        </div>

        <!-- Second Row of Images -->
        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/wilayah.png"
            alt="wilayah"
          >
          <div class="text-overlay">
            <p class="state-name">
              KUALA LUMPUR
            </p>
            <p class="state-number">
              {{ getStatusOku('Kuala Lumpur') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/putra.png"
            alt="putra"
          >
          <div class="text-overlay">
            <p class="state-name">
              PUTRAJAYA
            </p>
            <p class="state-number">
              {{ getStatusOku('Putrajaya') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/penang.png"
            alt="penang"
          >
          <div class="text-overlay">
            <p class="state-name">
              PULAU PINANG
            </p>
            <p class="state-number">
              {{ getStatusOku('Pulau Pinang') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/perlis.png"
            alt=""
          >
          <div class="text-overlay">
            <p class="state-name">
              PERLIS
            </p>
            <p class="state-number">
              {{ getStatusOku('perlis') }}
            </p>
          </div>
        </div>
        
        <!-- Third Row of Images -->
        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/sabah.png"
            alt="Sabah"
          >
          <div class="text-overlay">
            <p class="state-name">
              SABAH
            </p>
            <p class="state-number">
              {{ getStatusOku('Sabah') }}
            </p>
          </div>
        </div>

        <div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/pahang1.png"
            alt="pahang"
          >
          <div class="text-overlay">
            <p class="state-name">
              PAHANG
            </p>
            <p class="state-number">
              {{ getStatusOku('Pahang') }}
            </p>
          </div>
        </div><div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/melaka.png"
            alt="Melaka"
          >
          <div class="text-overlay">
            <p class="state-name">
              MELAKA
            </p>
            <p class="state-number">
              {{ getStatusOku('Melaka') }}
            </p>
          </div>
        </div><div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/terengganu.png"
            alt="terengganu"
          >
          <div class="text-overlay">
            <p class="state-name">
              TERENGGANU
            </p>
            <p class="state-number">
              {{ getStatusOku('Terengganu') }}
            </p>
          </div>
        </div><div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/sembilan.png"
            alt="sembilan"
          >
          <div class="text-overlay">
            <p class="state-name">
              NEGERI SEMBILAN
            </p>
            <p class="state-number">
              {{ getStatusOku('Negeri Sembilan') }}
            </p>
          </div>
        </div><div class="image-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/perak1.png"
            alt="perak"
          >
          <div class="text-overlay">
            <p class="state-name">
              PERAK
            </p>
            <p class="state-number">
              {{ getStatusOku('Perak') }}
            </p>
          </div>
        </div>
      </div>
      <Update />
    </div>

    <div class="content-wrapper">
      <h2>JUMLAH BILANGAN AHLI MAJLIS PBT MENGIKUT UMUR</h2>

      <!-- umur -->
      <div class="umur">
        <div class="umur-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/first.png"
            alt="First Image"
          >
          <div class="text-overlay-left">
            <h3>26 KEBAWAH</h3>
            <div class="values-side-by-side">
              <p><span class="value ">{{ detailsUmurData[0]?.bawah_26 ?? 0 }}</span></p>
            </div>
          </div>
        </div>

        <div class="umur-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/second.png"
            alt="Second Image"
          >
          <div class="text-overlay-right">
            <h3>26 - 40</h3>
            <div class="values-side-by-side">
              <p><span class="value ">{{ detailsUmurData[0]?.umur26_40 ?? 0 }}</span></p>
            </div>
          </div>
        </div>

        <div class="umur-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/third.png"
            alt="Third Image"
          >
          <div class="text-overlay-left">
            <h3>41 - 59</h3>
            <div class="values-side-by-side">
              <p><span class="value ">{{ detailsUmurData[0]?.umur41_59 ?? 0 }}</span></p>
            </div>
          </div>
        </div>

        <div class="umur-container">
          <img
            src="@/assets/jkt/AhliMajlisPBT/foor.png"
            alt="Fourth Image"
          >
          <div class="text-overlay-right">
            <h3>ATAS 60</h3>
            <div class="values-side-by-side">
              <p><span class="value ">{{ detailsUmurData[0]?.atas_60 ?? 0 }}</span></p>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>
    
    <div class="content-wrapper">
      <h2>BILANGAN AHLI MAJLIS MENGIKUT PARTI POLITIK</h2>
      <div class="chart-wrapper">
        <DonutChart :chart-data="PartiPolitikPieChartData" />
        <Update />
      </div>
    </div>
  </AdminBackground>
  <PrimaryModule />
  <InspektoratMenu />
</template>

<script setup>
import { useHttpService } from "@/httpService"
import * as am5 from "@amcharts/amcharts5"
import axios from "axios"
import moment from "moment"
import { onMounted, ref, toRaw, watch } from 'vue'

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const { httpGet, numberWithCommas, calculatePercentage } = useHttpService()

// Data references
const ahli = ref({ 
  selectedYear: moment().format('YYYY'), 
  overallData: {
    keseluruhan: 0,
    lelaki: 0,
    wanita: 0,
  },
})

const responseData = ref(null)
const councils = ref({})
const statesData = ref()
const overallData = ref()
const detailsUmurData = ref()
const date = ref()
const years = ref([])
const tahun = ref()
const states = ref(["Semua Negeri"])
const pbt = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const PeratusanData = ref([])
const PeratusanNames = ref([])

const PartiPolitikPieChartData=ref([])

const MaleData = ref([])
const FemaleData = ref([])


function getStatusOku(stateName) {
  const stateData = statesData.value.find(item => item.state === stateName)
  
  return stateData ? stateData.status_oku : '0'
}


async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}`

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }
    
    // const apiUrl = import.meta.env.VITE_EPROFIL_API_URL;
    // const url = `${apiUrl}inspektorat/ahli-majlis-pbt?${queryParams}`
    // const response = await axios.get(url)

    const url = `inspektorat/ahli-majlis-pbt?${queryParams}`

    const response = await httpGet(url)

    years.value = response.years

  
  

    states.value = ["Semua Negeri"]




    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

 

//       states.value = ["Semua Negeri"]
//     if (Array.isArray(response.states)) {
//   response.states.forEach(state => {
//     if (state && state !== "Modified Pbt") {
//       states.value.push(state)
//     }
//   })
//     console.log("States:", states.value)
// }


    councils.value = response.councils
    responseData.value = response
    statesData.value = response.data.negeri
    overallData.value = response.data.keseluruhan
    detailsUmurData.value = response.data.umur
    date.value = response.data
    tahun.value = response.data_information.year
   

    const peratusan = responseData.value.data.negeri

    PeratusanNames.value = peratusan.map(item => item.state)
    PeratusanData.value = peratusan.map(item => parseInt(item.peratusan_perempuan, 10)) // Original data

    const partiPolitik = responseData.value.data.parti_politik.senarai

    ahli.value = {
      ...ahli.value,
      overallData: {
        keseluruhan: overallData.value.jumlah_keseluruhan_ahli_majlis,
        lelaki: overallData.value.jumlah_keseluruhan_ahli_majlis_lelaki,
        wanita: overallData.value.jumlah_keseluruhan_ahli_majlis_wanita,
      },
      councilList: councils.value,
      years: years,
      selectedYear: tahun,
    }

    if (date.value) {
      ahli.value.ahliMajlisDate = moment(date.value).toDate()
    }


    //here data for pie chart
    PartiPolitikPieChartData.value = Object.entries(partiPolitik).map(
      ([name, value]) => ({
        name,
        value,
      }),
    )

    const male = response.data.negeri

    const data = [
      {
        name: "Johor",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/flag-of-johor_ver_1.png",
        },
        color: am5.color("#06287f"), // Correct color
      },
      {
        name: "Kedah",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/kedah-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#064401"), // Green for Kedah
      },
      {
        name: "Kelantan",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/kelantan-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#a80000"), // Red for Kelantan
      },
      {
        name: "Negeri Sembilan",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/negeri-sembilan-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#ec4747"), // Orange for Negeri Sembilan
      },
      {
        name: "Pahang",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/screenshot-2023-06-26-at-5.19.54-pm_ver_1.png",
        },
        color: am5.color("#457ae0"), // Purple for Pahang
      },
      {
        name: "Pulau Pinang",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/flag-of-penang_ver_1.png",
        },
        color: am5.color("#9747ff"), // Brown for Pulau Pinang
      },
      {
        name: "Perak",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/screenshot-2023-06-26-at-5.21.54-pm_ver_1.png",
        },
        color: am5.color("#fab400"), // Pink for Perak
      },
      {
        name: "Selangor",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/selangor-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#faf000"), // Gray for Selangor
      },
      {
        name: "Terengganu",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/screenshot-2023-06-26-at-5.51.42-pm_ver_1.png",
        },
        color: am5.color("#330471"), // Yellow-green for Terengganu
      },
      {
        name: "Sarawak",
        pictureSettings: {
          src: "https://images.twinkl.co.uk/tw1n/image/private/t_630/u/ux/sarawak-flag-with-black-borders_ver_1.png",
        },
        color: am5.color("#ff9f47"), // Teal for Sarawak
      },
    ]

    // Update with data from the API
    MaleData.value = data.map(item => {
      const stateData = male.find(s => s.state === item.name)

      const updatedData = {
        ...item,
        steps: stateData ? parseInt(stateData.lelaki) : 0,
      }
 
      return updatedData
    })



    FemaleData.value = data.map(item => {
      const stateData = male.find(s => s.state === item.name)

      const updatedData = {
        ...item,
        steps: stateData ? parseInt(stateData.wanita) : 0,
      }
   
      return updatedData
    })

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []

 
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }


  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }


  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }


  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {

    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

}


onMounted(() => {
  loadDataFromApi()
  
})

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}


.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
  
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; /* Adjusted size */
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; /* Match width to the image size */
  margin-block-start: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 40px 10px;
  text-align: start;
}

.majlis-content {
  display: flex;
  justify-content: center; 
  align-items: center;  
  gap: 50px;             
  inline-size: 100%;
  max-inline-size: 1200px; 
  margin: 0 auto;         
}

.majlis-item {
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;    
  text-align: center;      
  margin: 0;
}

.majlis-image {
  display: block;
  margin: 0 auto 20px;      
  max-inline-size: 250px;    
  width: 100%;
}

.majlis-numbers {
  display: flex;
  flex-direction: column;
  align-items: center;   
  justify-content: center;
  padding: 10px;
  color: rgb(21, 0, 105);
  font-weight: bold;
  text-align: center;     
}

.majlis-numbers p {
  margin: 0;
  font-size: 2.5rem; 
}

.majlis-numbers span {
  color: rgb(21, 0, 105);
  font-size: 1.5rem; 
  margin-block-start: 3px;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1200px;
}

/* Image Grid */
.image-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(5, 1fr);
  inline-size: 100%;
  max-inline-size: 1200px;
}

.text-overlay {
  position: absolute;
  border-end-end-radius: 10px;
  border-end-start-radius: 10px;
  inline-size: 100%;
  inset-block-end: 0;
  padding-block: 20px;
  padding-inline: 0;
  text-align: center;
}

.state-name {
  color: #150069;
  font-size: 20px;
  font-weight: 600;
  margin-block-end: 0;
}

.state-number {
  position: relative;
  color: #a80000;
  font-size: 46px;
  font-weight: 600;
  inset-inline-end: -20px; 
  margin-block: -5px 10px; 
  padding-inline-end: 70px; 
  text-align: end; 
}

.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 10%);
  inline-size: 100%;
  padding-block-start: 125%;
}

.image-container img {
  position: absolute;
  block-size: 100%;
  border-start-end-radius: 10px;
  border-start-start-radius: 10px;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  object-fit: cover;
}

.age-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  inline-size: 100%;
  max-inline-size: 1200px;
}

.age-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 900px;
}

.people-image {
  inline-size: 40%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 500px;
}

.oku-text-box {
  position: relative;
  inline-size: 250px;
  margin-block-end: 20px;
}

.oku-text-box img {
  border-radius: 10px;
  block-size: auto;
  inline-size: 100%;
}

.text {
  position: absolute;
  z-index: 1;
  color: #150069;
  inline-size: 100%;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
}

h3 {
  color: #150069;
  font-size: 1.8rem;
}

.value {
  color: #a80000;
  font-size: 2rem;
  font-weight: bold;
}

.umur {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-block-end: 30px;
}

.umur-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: auto;
  max-inline-size: 900px;
}


.text-overlay-left,
.text-overlay-right,
.text-overlay-center {
  position: absolute;
  color: #fff;
  font-family: Arial, sans-serif;
  inset-block-start: 50%;
  transform: translateY(-50%);
}

.text-overlay-left {
  inset-inline-start: 20%;
  text-align: start;
}

.text-overlay-right {
  inset-inline-end: 20%;
  text-align: end;
}


.text-overlay-left h3,
.text-overlay-right h3,
.text-overlay-center h3 {
  block-size: 70px;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
}

.text-overlay-left p,
.text-overlay-right p,
.text-overlay-center p {
  color: #150069;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
}

.values-side-by-side {
  display: flex;
  flex-wrap: wrap; 
  gap: 80px;
}

.text {
  color: #150069;
}



@media (max-width: 770px) {
  .image-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .majlis-content {
    flex-direction: column;
    align-items: center;
  }

  .majlis-item {
    margin-block: 20px;
    margin-inline: 0;
  }

  .chart-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1.2rem;
    text-align: left;
  }

  .content-wrapper {
    padding: 10px;
  }

.text-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    text-align: center;
  }

  .state-name {
    font-size: 1.4rem; 
    margin-bottom: 55px; 
    color: #150069;
    font-weight: bold;
  }

  .state-number {
  font-size: 1.9rem; 
  font-weight: bold;
  margin-bottom: 65px;
  margin-left: 90px; /* Adjust this value as needed to move it right */
}
}

@media (max-width: 480px) {
  .image-grid {
    grid-template-columns: 1fr;
  }

  .content-wrapper {
    padding: 5px;
  }


  .umur {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }

  .umur-container {
    flex: 1 1 100%; /* Full width for each item */
    max-width: 100%;
    margin: 0 auto;
  }

  .text-overlay-left, .text-overlay-right {
    font-size: 0.8rem; /* Smaller font size for labels */
    top: 5px;
  }


  .values-side-by-side .value {
    font-size: 1rem !important; /* Smaller font for the value */
  }
  .values-side-by-side {
    font-size: 0.2rem; /* Smaller font size for values */
    bottom: 5px;
    right: 5px;
  }


  .values-side-by-side .value {
    font-size: 1.2rem; 
  }

}
</style>
